import React, { useState, useEffect, useRef } from "react";
import * as Icon from "react-feather";
import { moveItem, withDisplayOrder } from "./reorder";
import VisibilityFormItem from "../../components/input/visibility-form-item";
import { VISIBILITY_DEFAULT } from "../../constants/app-constants";
import {
  Button,
  Form,
  Input,
  Modal,
  Tabs,
  Select,
  Col,
  Divider,
  Row,
  Avatar,
  Card,
} from "antd";
import { useDispatch } from "react-redux";
import templateContentService from "../../services/template-content-service";
import appLoaderAction from "../../redux/action/app-loader-action";
import notifyUtitls from "../../utils/notify-utils";
import UploadImage from "../../components/upload/image";
import UploadFile from "../../components/upload/file";
import {
  fileTYPE_IMG,
  groupType,
  fileTYPE_DOCUMENT,
  PREVIEW_TYPE,
} from "../../constants/app-constants";
import fileUtils from "../../utils/file-utils";
import HtmlEditor from "../../components/input/html-editor";
import constantService from "../../services/constant-service";
import { UploadOutlined, UserOutlined } from "@ant-design/icons";
import { MenuOutlined } from "@ant-design/icons";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import EditableTagGroup from "../../components/input/editable-tag-group";
import SunEditor from "suneditor-react";
import { openWebsitePreview } from "../../utils/preview-utils";

const { TabPane } = Tabs;
const { Option } = Select;

const langTH = "TH";
const langEN = "EN";

const DragHandle = SortableHandle(() => (
  <MenuOutlined style={{ cursor: "pointer", color: "#999" }} />
));

const renderTabPeopleContent = (
  lang,
  index,
  value,
  onChangeFirstName,
  onChangeLastName,
  onChangeDepartment,
  onChangePosition,
  onChangeEmail,
  onChangeResponsibilities,
  onAddResponsibility, 
  onRemoveResponsibility,
) => {
  const { firstname, lastname, department, position, email, responsibilities } =
    value;

  const currentResponsibilities =
    lang === langTH
      ? responsibilities?.responsibilitiesTH
      : responsibilities?.responsibilitiesEN;

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form layout="vertical" name="basic">
            <Form.Item
              key={
                (lang === langTH
                  ? "firstname.firstnameTH"
                  : "firstname.firstnameEN") + index
              }
              className="mb-2"
              rules={
                lang === langTH
                  ? [
                      {
                        required: true,
                      },
                    ]
                  : [
                      {
                        required: false,
                      },
                    ]
              }
            >
              <span>{lang === langTH ? "ชื่อ" : "Fist Name"}</span>{" "}
              <span class="red-star">{lang === langTH ? "*" : ""}</span>
              {lang === langTH ? (
                <Input
                  type="text"
                  value={firstname.firstnameTH}
                  onChange={({ target }) =>
                    onChangeFirstName(index, lang)(target.value)
                  }
                />
              ) : (
                <Input
                  type="text"
                  value={firstname.firstnameEN}
                  onChange={({ target }) =>
                    onChangeFirstName(index, lang)(target.value)
                  }
                />
              )}
            </Form.Item>
          </Form>
        </Col>
        <Col span={12}>
          <Form layout="vertical" name="basic">
            <Form.Item
              key={
                (lang === langTH
                  ? "lastname.lastnameTH"
                  : "lastname.lastnameEN") + index
              }
              className="mb-2"
              rules={
                lang === langTH
                  ? [
                      {
                        required: true,
                      },
                    ]
                  : [
                      {
                        required: false,
                      },
                    ]
              }
            >
              <span>{lang === langTH ? "นามสกุล" : "Last Name"}</span>{" "}
              <span class="red-star">{lang === langTH ? "*" : ""}</span>
              {lang === langTH ? (
                <Input
                  type="text"
                  value={lastname.lastnameTH}
                  onChange={({ target }) =>
                    onChangeLastName(index, lang)(target.value)
                  }
                />
              ) : (
                <Input
                  type="text"
                  value={lastname.lastnameEN}
                  onChange={({ target }) =>
                    onChangeLastName(index, lang)(target.value)
                  }
                />
              )}
            </Form.Item>
          </Form>
        </Col>
        <Col span={12}>
          <Form layout="vertical" name="basic">
            <Form.Item
              label={lang === langTH ? "หน่วยงาน" : "Department"}
              key={
                (lang === langTH
                  ? "department.departmentTH"
                  : "department.departmentEN") + index
              }
              className="mb-2"
            >
              {lang === langTH ? (
                <Input
                  type="text"
                  value={department.departmentTH}
                  onChange={({ target }) =>
                    onChangeDepartment(index, lang)(target.value)
                  }
                />
              ) : (
                <Input
                  type="text"
                  value={department.departmentEN}
                  onChange={({ target }) =>
                    onChangeDepartment(index, lang)(target.value)
                  }
                />
              )}
            </Form.Item>
          </Form>
        </Col>
        <Col span={12}>
          <Form layout="vertical" name="basic">
            <Form.Item
              label={lang === langTH ? "ตำแหน่ง" : "Position"}
              key={
                (lang === langTH
                  ? "position.positionTH"
                  : "position.positionEN") + index
              }
              className="mb-2"
            >
              {lang === langTH ? (
                <Input
                  type="text"
                  value={position.positionTH}
                  onChange={({ target }) =>
                    onChangePosition(index, lang)(target.value)
                  }
                />
              ) : (
                <Input
                  type="text"
                  value={position.positionEN}
                  onChange={({ target }) =>
                    onChangePosition(index, lang)(target.value)
                  }
                />
              )}
            </Form.Item>
          </Form>
        </Col>
        <Col span={12}>
          <Form layout="vertical" name="basic">
            <Form.Item
              label={lang === langTH ? "อีเมล" : "E-mail"}
              key={"email" + index}
              className="mb-2"
            >
              {
                <Input
                  type="text"
                  value={email}
                  onChange={({ target }) =>
                    onChangeEmail(index, lang)(target.value)
                  }
                />
              }
            </Form.Item>
          </Form>
        </Col>

        <Col span={18}>
          <Form layout="vertical" name="basic">
            <Form.Item
              label={lang === langTH ? "อำนาจ/หน้าที่" : "Responsibilities"}
              className="mb-2"
            >
              {currentResponsibilities?.map((resp, respIndex) => (
                <div
                  key={`resp-${index}-${lang}-${respIndex}`}
                  className="d-flex mb-2"
                  style={{ display: "flex", marginBottom: "8px" }}
                >
                  <Input
                    type="text"
                    value={resp}
                    onChange={({ target }) =>
                      onChangeResponsibilities(
                        index,
                        lang,
                        respIndex,
                      )(target.value)
                    }
                    style={{ marginRight: "8px" }}
                  />
                  <Button
                    type="primary"
                    danger
                    onClick={onRemoveResponsibility(index, lang, respIndex)}
                  >
                    <Icon.Trash size={18} />
                  </Button>
                </div>
              ))}

              <Button
                type="dashed"
                onClick={onAddResponsibility(index, lang)}
                style={{ marginTop: "8px" }}
              >
                <Icon.Plus className="me-1" size={18} />{" "}
                {lang === langTH ? "เพิ่มอำนาจ/หน้าที่" : "Add Responsibility"}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

const SortableItem = SortableElement(
  ({
    value,
    indexKey,
    onChangeFirstName,
    onChangeLastName,
    onChangeDepartment,
    onChangePosition,
    onChangeEmail,
    onChangeResponsibilities,
    onAddResponsibility,
    onRemoveResponsibility,
    renderTabPeopleContent,
    onChangeImagePeopleContent,
    onRemovePeople,
    editData,
  }) => {
    return (
      <div style={{ margin: "10px" }}>
        <Row gutter={16}>
          <Col span={1}>
            <DragHandle />
          </Col>
          <Col span={7}>
            <UploadImage
              listType="picture-card"
              showUploadList={false}
              accept={fileTYPE_IMG}
              onChange={onChangeImagePeopleContent(indexKey)}
            >
              {value.attachImage[0] ? (
                <img
                  src={
                    value.attachImage[0].tempFilename
                      ? fileUtils.getTempFileRenderUrl(
                          value.attachImage[0].tempFilename,
                          value.attachImage[0].type,
                        )
                      : fileUtils.getFileRenderUrl(
                          groupType.TEMPLATE,
                          editData ? editData.templateId : null,
                          value.attachImage[0].originalFilename,
                        )
                  }
                  alt="avatar"
                  style={{ width: "100%" }}
                />
              ) : (
                <Avatar
                  size={70}
                  icon={<UserOutlined />}
                  className="m-auto d-block"
                />
              )}
            </UploadImage>
            {/* //Recommended size */}
            <label className="text-danger">
              * ขนาดรูปภาพที่แนะนำคือ 400x400 pixels.
            </label>
          </Col>

          <Col span={16}>
            <Tabs defaultActiveKey="1">
              <TabPane tab="ภาษาไทย" key={"peopleTab" + indexKey + langTH}>
                <Divider orientation="left" plain>
                  <h5 className="color-primary-title mb-0">
                    {"รายการที่ " + (indexKey + 1)}
                  </h5>
                </Divider>

                {renderTabPeopleContent(
                  langTH,
                  indexKey,
                  value,
                  onChangeFirstName,
                  onChangeLastName,
                  onChangeDepartment,
                  onChangePosition,
                  onChangeEmail,
                  onChangeResponsibilities,
                  onAddResponsibility,
                  onRemoveResponsibility,
                )}
              </TabPane>
              <TabPane tab="English" key={"peopleTab" + indexKey + langEN}>
                <Divider orientation="left" plain>
                  <h5 className="color-primary-title mb-0">
                    {"People List " + (indexKey + 1)}
                  </h5>
                </Divider>
                {renderTabPeopleContent(
                  langEN,
                  indexKey,
                  value,
                  onChangeFirstName,
                  onChangeLastName,
                  onChangeDepartment,
                  onChangePosition,
                  onChangeEmail,
                  onChangeResponsibilities,
                  onAddResponsibility,
                  onRemoveResponsibility,
                )}
              </TabPane>
            </Tabs>
          </Col>

          <div className="text-right mt-3">
            <Button
              key={"submit" + indexKey}
              type="danger"
              className="me-2"
              style={{ minWidth: 30 }}
              onClick={onRemovePeople(indexKey)}
            >
              <Icon.Trash size={18} />
            </Button>
          </div>
        </Row>
        <Divider />
      </div>
    );
  },
);

const SortableList = SortableContainer(
  ({
    items,
    onChangeFirstName,
    onChangeLastName,
    onChangeDepartment,
    onChangePosition,
    onChangeImagePeopleContent,
    onChangeEmail,
    onChangeResponsibilities,
    onAddResponsibility,
    onRemoveResponsibility,
    onRemovePeople,
    editData,
  }) => {
    return (
      <div>
        {items.map((item, index) => {
          return (
            <div>
              <SortableItem
                key={`item-${index}`}
                value={item}
                indexKey={index}
                index={index}
                onChangeFirstName={onChangeFirstName}
                onChangeLastName={onChangeLastName}
                onChangeDepartment={onChangeDepartment}
                onChangePosition={onChangePosition}
                onChangeEmail={onChangeEmail}
                onChangeResponsibilities={onChangeResponsibilities}
                onAddResponsibility={onAddResponsibility}
                onRemoveResponsibility={onRemoveResponsibility}
                renderTabPeopleContent={renderTabPeopleContent}
                onChangeImagePeopleContent={onChangeImagePeopleContent}
                onRemovePeople={onRemovePeople}
                editData={editData}
              />
            </div>
          );
        })}
      </div>
    );
  }
);

/**
 * NMU-458: template types whose page body is rendered from another module
 * rather than from content blocks typed into this form. They need only a main
 * title, so they share one render/save/validate path.
 *
 * These are TemplateType enum VALUES (nmu-common-service) — 6 = Programs,
 * 7 = Calendar.
 */
const DYNAMIC_LISTING_TYPES = [6, 7];

const AddEditTemplateContentDialog = ({
  isShow,
  onCancel,
  onSaveComplete,
  editData,
}) => {
  const dispatch = useDispatch();
  const [templateList, setTemplateList] = useState([]);
  const [form] = Form.useForm();
  const [templateType, setTemplateType] = useState(null);
  const [keywordList, setKeywordList] = useState([]);

  //Template1
  const [documentList, setDocumentList] = useState([]);
  const [bannerList, setBannerList] = useState([]);
  const [editorContentTH, setEditorContentTH] = useState("");
  const [editorContentEN, setEditorContentEN] = useState("");
  const [titleTH, setTitleTH] = useState(null);
  const [titleEN, setTitleEN] = useState(null);
  const [mainTitleTH, setMainTitleTH] = useState(null);
  const [mainTitleEN, setMainTitleEN] = useState(null);
  const [facebookLinkValue, setFacebookLinkValue] = useState(null);

  //Template2
  const [itemList, setItemList] = useState([]);

  //Template3
  const [peopleList, setPeopleList] = useState([]);

  useEffect(() => {
    async function initData() {
      const { templateType } = await constantService.getTemplateType();
      templateType.forEach((x) => {
        x.value = parseInt(x.value);
      });

      //test only
      // console.log( 'templateType ', templateType);
      // templateType.push({value: 3, labelEn: 'Organizational Structure2', labelTh: 'โครงสร้างองค์กรแบบที่ 2'})
      setTemplateList(templateType);
    }

    if (!isShow) {
      setTemplateType(null);
      setTemplateList([]);
      initDefaultTemplate1();
      initDefaultTemplate2();
      initDefaultTemplate3();
      form.resetFields();
    } else {
      setTemplateType(null);
      initData();
      initDefaultTemplate1();
      initDefaultTemplate2();
      initDefaultTemplate3();
      initDefaultTemplate5();
    }
  }, [isShow]);

  /**
   * NMU-544: the page's first content block, whatever shape the record is in.
   *
   * `content` used to be read as `editData.content[0]` directly. When the record
   * arrived without it — as it did once NMU-536 excluded the body from the
   * enquiry the list was handing over — that threw inside this effect, which
   * unmounts the tree: the editor lost the entire admin to a white screen, not
   * just this dialog.
   *
   * The record is loaded through getById now (see the Content page's
   * onClickEdit), so it carries the body. This is the belt to that braces: a
   * malformed page opens an empty form, which an editor can see and report,
   * instead of taking the application down.
   */
  const firstContent = () => (editData && editData.content && editData.content[0]) || {};

  useEffect(() => {
    if (isShow && editData) {
      setKeywordList(firstContent().keywordList ? firstContent().keywordList : []);
      setTemplateType(editData.templateType);
      setFormByTemplate();
      setFacebookLinkValue(
        firstContent().facebookLink ? firstContent().facebookLink : ""
      );
    } else {
      setKeywordList([]);
      setFacebookLinkValue("");
    }
  }, [isShow, editData]);

  useEffect(() => {
    if (isShow && editData) {
      setFormByTemplate();
    }
  }, [isShow, editData, templateType]);

  function initDefaultTemplate1() {
    setDocumentList([]);
    setBannerList([]);
    setEditorContentTH("");
    setEditorContentEN("");
    setTitleTH("");
    setTitleEN("");
    setMainTitleEN("");
    setMainTitleTH("");
    setFacebookLinkValue("");
  }

  function initDefaultTemplate2() {
    setItemList([]);
  }

  function initDefaultTemplate3() {
    setPeopleList([]);
  }

  function initDefaultTemplate5() {
    setPanes([]);
  }

  function setFormByTemplate() {
    setMainTitleTH(editData.mainTitle.titleTH);
    setMainTitleEN(editData.mainTitle.titleEN);

    switch (templateType) {
      case 3:
      case 0:
        if (editData.templateType === templateType) {
          const contentTemplate1 = firstContent();
          form.setFieldsValue({
            templateType: editData.templateType,
            mainTitleTH: editData.mainTitle.titleTH,
            mainTitleEN: editData.mainTitle.titleEN,
            titleTH: contentTemplate1.title?.titleTH,
            titleEN: contentTemplate1.title?.titleEN,
            urlSuffix: editData.urlSuffix,
          });

          const newBannerList = (
            contentTemplate1?.attachImage ? contentTemplate1?.attachImage : []
          ).map((item, index) => {
            return fileUtils.convertFileBeanToFileAnt(index, item, {
              groupType: groupType.TEMPLATE,
              id: editData.templateId,
            });
          });

          const newDocumentList = (
            contentTemplate1?.documentList ? contentTemplate1?.documentList : []
          ).map((item, index) => {
            return fileUtils.convertFileBeanToFileAnt(index, item, {
              groupType: groupType.TEMPLATE,
              id: editData.templateId,
            });
          });

          setTitleTH(contentTemplate1.title?.titleTH);
          setTitleEN(contentTemplate1.title?.titleEN);
          setBannerList(newBannerList);
          setTemplateType(editData.templateType);
          setEditorContentTH(contentTemplate1.content.contentTH);
          setEditorContentEN(contentTemplate1.content.contentEN);
          setDocumentList(newDocumentList);
        } else {
          initDefaultTemplate1();
        }
        break;
      case 1:
        if (editData.templateType === templateType) {
          const object = { ...editData };

          const newItemList = (object.content || []).map((item) => {
            return {
              ...item,
              documentList: (item.documentList ? item.documentList : []).map(
                (item, index) => {
                  return fileUtils.convertFileBeanToFileAnt(index, item, {
                    groupType: groupType.TEMPLATE,
                    id: editData.templateId,
                  });
                }
              ),
            };
          });

          setItemList(newItemList);

          form.setFieldsValue({
            templateType: editData.templateType,
            mainTitleTH: editData.mainTitle.titleTH,
            mainTitleEN: editData.mainTitle.titleEN,
            urlSuffix: editData.urlSuffix,
          });
        } else {
          initDefaultTemplate2();
        }
        break;
      case 2:
      case 4:
        if (editData.templateType === templateType) {
          const object = { ...editData };

          const newPeopleList = (object.content || []).map((item) => {
            return {
              ...item,
              documentList: (item.documentList ? item.documentList : []).map(
                (item, index) => {
                  return fileUtils.convertFileBeanToFileAnt(index, item, {
                    groupType: groupType.TEMPLATE,
                    id: editData.templateId,
                  });
                }
              ),
            };
          });

          setPeopleList(newPeopleList);
          form.setFieldsValue({
            templateType: editData.templateType,
            mainTitleTH: editData.mainTitle.titleTH,
            mainTitleEN: editData.mainTitle.titleEN,
            urlSuffix: editData.urlSuffix,
          });
        } else {
          initDefaultTemplate3();
        }
        break;
      case 5:
        if (editData.templateType === templateType) {
          const object = { ...editData };
          const newTablist = (object.content || []).map((item) => {
            return {
              ...item,
            };
          });
          // console.log(newTablist);
          const thisdata = convertTabForUse(newTablist);
          setPanes(thisdata);
          setActiveKey(thisdata[0]?.key);
          //  setMainTabData(newTablist[0]);
          setLeftActiveKey(thisdata[0]?.crosstabDetailList[0]?.key);

          form.setFieldsValue({
            templateType: editData.templateType,
            mainTitleTH: editData.mainTitle.titleTH,
            mainTitleEN: editData.mainTitle.titleEN,
            titleTH: newTablist[0]?.title.titleTH,
            titleEN: newTablist[0]?.title.titleEN,
            urlSuffix: editData.urlSuffix,
          });
        } else {
          initDefaultTemplate5();
        }
        break;
      default:
        return null;
    }
  }

  function convertTabForUse(listMainTab) {
    const newTablist = listMainTab.map((mainTab) => {
      return {
        ...mainTab,
        key: mainTab.contentId,
        crosstabDetailList: convertSub(mainTab.crosstabDetailList),
      };
    });
    return newTablist;
  }

  function convertSub(listSub) {
    const subTab = listSub.map((detail) => {
      return {
        ...detail,
        key: detail.contentId,
        linkDetailList: convertSub2(detail.linkDetailList),
      };
    });
    return subTab;
  }

  function convertSub2(listSub) {
    const subTab = listSub.map((detail) => {
      return {
        ...detail,
        key: detail.contentId,
      };
    });
    return subTab;
  }

  function validateArticleContent() {
    let result = false;
    if (templateType !== 0 && templateType !== 3) {
      return true;
    }

    const isMainTitleInvalid = !mainTitleTH;
    const isTitleInvalid = !titleTH;
    const isContentInvalid = !editorContentTH;

    let invalidMsg = null;
    if (isMainTitleInvalid || isTitleInvalid || isContentInvalid) {
      if (!invalidMsg) {
        invalidMsg = "โปรดระบุ";
      }

      invalidMsg += isMainTitleInvalid ? " ชื่อเนื้อหาหลัก" : "";
      invalidMsg += isTitleInvalid ? " ชื่อเนื้อหา" : "";
      invalidMsg += isContentInvalid ? " รายละเอียดเนื้อหา" : "";

      if (invalidMsg) {
        notifyUtitls.warning("แจ้งเตือน", invalidMsg + "ให้ครบถ้วน");
      }
    } else {
      result = true;
    }

    return result;
  }

  function validateGridContent() {
    let result = false;
    if (templateType !== 1) {
      return true;
    }

    if (itemList.length === 0) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุเนื้อหาอย่างน้อย 1 รายการ");
    } else if (!mainTitleTH) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุชื่อเนื้อหาหลักให้ครบถ้วน");
    } else {
      const isTitleInvalid = itemList.some((x) => !x.title.titleTH);
      const isDescriptionInvalid = itemList.some(
        (x) => !x.description.descriptionTH
      );
      const isContentInvalid = itemList.some((x) => !x.content.contentTH);

      /*
        NMU-558: รูปภาพ is not required.

        A content item's medium may be a video embedded in รายละเอียดเนื้อหา and
        nothing else, and this refused to save it — the editor had filled every
        field the content actually has and was told to supply an image it does
        not have. The upload stays where it is; only the demand is gone.
      */
      let invalidMsg = null;
      if (isTitleInvalid || isDescriptionInvalid || isContentInvalid) {
        if (!invalidMsg) {
          invalidMsg = "โปรดระบุ";
        }

        invalidMsg += isTitleInvalid ? " ชื่อเนื้อหา" : "";
        invalidMsg += isDescriptionInvalid ? " คำอธิบาย" : "";
        invalidMsg += isContentInvalid ? " รายละเอียดเนื้อหา" : "";

        if (invalidMsg) {
          notifyUtitls.warning("แจ้งเตือน", invalidMsg + "ให้ครบถ้วนทุกรายการ");
        }
      } else {
        result = true;
      }
    }

    return result;
  }

  function validateMultiTabContent() {
    let result = false;
    if (templateType !== 5) {
      return true;
    }

    console.log(panes);
    if (panes.length === 0) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุเนื้อหาอย่างน้อย 1 รายการ");
    } else if (!mainTitleTH) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุชื่อเนื้อหาหลักให้ครบถ้วน");
    } else {
      // ชื่อแท็บหลัก
      // ชื่อแท็บเมนู
      // ชื่อหัวข้อ

      let isMainTabTitleInvalid = false;
      let isCrossTabTitleInvalid = false;
      let isCrossTabDetailTitleInvalid = false;

      //loop check title all level content crosstab
      for (let i = 0; i < panes.length - 1; i++) {
        let mainData = panes[i];
        if (
          (mainData.title === null && !mainData.title?.titleTH) ||
          mainData.title?.titleTH === ""
        ) {
          isMainTabTitleInvalid = true;
          break;
        }
        if (mainData?.crosstabDetailList.length > 0) {
          const crossTabList = mainData.crosstabDetailList;
          for (let i = 0; i < crossTabList.length - 1; i++) {
            let crossTabData = crossTabList[i];

            if (
              (crossTabData.title === null && !crossTabData.title?.titleTH) ||
              crossTabData.title?.titleTH === ""
            ) {
              isCrossTabTitleInvalid = true;
              break;
            }

            if (crossTabData?.linkDetailList.length > 0) {
              const linkDetailList = crossTabData.linkDetailList;
              for (let i = 0; i < linkDetailList.length - 1; i++) {
                let linkDetailData = linkDetailList[i];

                if (
                  (linkDetailData.title === null &&
                    !linkDetailData.title?.titleTH) ||
                  linkDetailData.title?.titleTH === ""
                ) {
                  isCrossTabDetailTitleInvalid = true;
                  break;
                }
              }
            }
          }
        }
      }

      let invalidMsg = null;
      if (
        isMainTabTitleInvalid ||
        isCrossTabTitleInvalid ||
        isCrossTabDetailTitleInvalid
      ) {
        if (!invalidMsg) {
          invalidMsg = "โปรดระบุ";
        }

        invalidMsg += isMainTabTitleInvalid ? " ชื่อแท็บหลัก" : "";
        invalidMsg += isCrossTabTitleInvalid ? " ชื่อแท็บเมนู" : "";
        invalidMsg += isCrossTabDetailTitleInvalid ? " ชื่อหัวข้อ" : "";

        if (invalidMsg) {
          notifyUtitls.warning("แจ้งเตือน", invalidMsg + "ให้ครบถ้วนทุกรายการ");
        }
      } else {
        result = true;
      }
    }

    return result;
  }

  function validatePeopleContent() {
    let result = false;
    if (templateType !== 2 && templateType !== 4) {
      return true;
    }

    if (peopleList.length === 0) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุเนื้อหาอย่างน้อย 1 รายการ");
    } else if (!mainTitleTH) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุชื่อเนื้อหาหลักให้ครบถ้วน");
    } else {
      const isFirstnameInvalid = peopleList.some(
        (x) => !x.firstname.firstnameTH
      );
      const isLastnameInvalid = peopleList.some((x) => !x.lastname.lastnameTH);
      // const isDepartmentInvalid = peopleList.some(x => !x.department.departmentTH );

      /*
        NMU-558: รูปภาพ is not required here either.

        The ticket is about a content item whose medium is a video, and this is
        the same demand on the same field one layout over — an entry with a name
        and no photograph is an ordinary thing, and refusing to save it was the
        rule, not a data problem.
      */
      let invalidMsg = null;
      if (isFirstnameInvalid || isLastnameInvalid) {
        if (!invalidMsg) {
          invalidMsg = "โปรดระบุ";
        }

        invalidMsg += isFirstnameInvalid ? " ชื่อ" : "";
        invalidMsg += isLastnameInvalid ? " นามสกุล" : "";
        // invalidMsg += (isDepartmentInvalid ? ' หน่วยงาน' : '');

        if (invalidMsg) {
          notifyUtitls.warning("แจ้งเตือน", invalidMsg + "ให้ครบถ้วนทุกรายการ");
        }
      } else {
        result = true;
      }
    }

    return result;
  }

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      if (
        validateGridContent() &&
        validatePeopleContent() &&
        validateArticleContent() &&
        validateMultiTabContent() &&
        validateDynamicListing()
      ) {
        try {
          dispatch(appLoaderAction.enable());
          let bean = getSaveBeanByTemplateType(values);
          if (!editData) {
            await templateContentService.add(bean);
          } else {
            await templateContentService.edit(bean);
          }

          dispatch(appLoaderAction.disale());

          onSaveComplete();

          notifyUtitls.success("สำเร็จ", "บันทึกสำเร็จ");
        } catch (err) {
          notifyUtitls.error(err);
          dispatch(appLoaderAction.disale());
        }
      }
    } catch (errorInfo) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุข้อมูลให้ครบถ้วน");
    }
  };

  /**common start**/
  /**
   * NMU-598: the visibility the form chose, applied to whichever layout built
   * the bean.
   *
   * Stamped in the dispatcher rather than in each of the five builders. They
   * each assemble their own shape and a field added to four of them is a page
   * type that silently cannot be made internal — and the admin would have no
   * way to tell, because the control is on screen either way.
   */
  function withVisibility(built, values) {
    if (built && built.bean) {
      built.bean.visibility = values.visibility || VISIBILITY_DEFAULT;
    }
    return built;
  }

  function getSaveBeanByTemplateType(values) {
    return withVisibility(buildSaveBeanByTemplateType(values), values);
  }

  function buildSaveBeanByTemplateType(values) {
    switch (templateType) {
      case 3:
      case 0:
        return getSaveBeanContent1(values);
      case 1:
        return getSaveBeanGridContent(values);
      case 2:
      case 4:
        return getSaveBeanPeopleContent(values);
      case 5:
        return getSaveBeanMultiTabContent(values);
      // NMU-458 / NMU-464: formats whose body comes from another module.
      case 6:
      case 7:
        return getSaveBeanDynamicListing(values);
      default:
        return null;
    }
  }

  const props = {
    multiple: true,
    listType: "picture",
  };

  const renderTemplateList = () => {
    return templateList.map(({ value, labelEn }) => (
      <Option value={value} key={value}>
        {labelEn}
      </Option>
    ));
  };

  const uploadButton = (
    <div>
      <div style={{ marginTop: 8 }}>อัปโหลดไฟล์</div>
    </div>
  );

  const renderMainTitle = (lang) => {
    return (
      <Form
        layout="vertical"
        name="add_edit_template_content"
        preserve={false}
        form={form}
        initialValues={{
          status: true,
        }}
      >
        <Form.Item
          name={lang === langTH ? "mainTitleTH" : "mainTitleEN"}
          label={lang === langTH ? "ชื่อเนื้อหาหลัก" : "Main Title"}
          key={lang === langTH ? "mainTitleTH" : "mainTitleEN"}
          rules={
            lang === langTH
              ? [
                  {
                    required: true,
                  },
                ]
              : [
                  {
                    required: false,
                  },
                ]
          }
        >
          {lang === langTH ? (
            <Input
              className="mb-4 pb-1"
              value={mainTitleTH}
              onChange={onChagneMainTitleTH}
            />
          ) : (
            <Input
              className="mb-4 pb-1"
              value={mainTitleEN}
              onChange={onChagneMainTitleEN}
            />
          )}
        </Form.Item>
      </Form>
    );
  };

  const onTemplateChange = () => {
    return (value) => {
      setTemplateType(value);
    };
  };

  const renderTemplate = () => {
    switch (templateType) {
      case 3:
      case 0:
        return renderContent1TemplateMain();
      case 1:
        return renderGridTemplateMain();
      case 2:
      case 4:
        return renderPeopleTemplateMain();
      case 5:
        return renderMultiTabContent();
      // NMU-458: Programs — the body is the Programs Listing, not content blocks.
      case 6:
        return renderDynamicListingTemplate(
          "เนื้อหาของหน้านี้ดึงจากเมนู Programs โดยอัตโนมัติ จึงระบุเฉพาะชื่อเนื้อหาหลัก"
        );
      // NMU-464: Calendar — the body is the Event Calendar Hub. Events are
      // managed under Calendar Activity, not typed in here.
      case 7:
        return renderDynamicListingTemplate(
          "เนื้อหาของหน้านี้ดึงจากเมนู Calendar Activity โดยอัตโนมัติ จึงระบุเฉพาะชื่อเนื้อหาหลัก"
        );
    }
  };

  const onChagneTitleTH = (event) => {
    setTitleTH(event.target.value);
  };

  const onChagneTitleEN = (event) => {
    setTitleEN(event.target.value);
  };

  const onChagneMainTitleTH = (event) => {
    setMainTitleTH(event.target.value);
  };

  const onChagneMainTitleEN = (event) => {
    setMainTitleEN(event.target.value);
  };

  const onChagneFacebookLink = (event) => {
    setFacebookLinkValue(event.target.value);
  };

  const onPreview = async () => {
    const values = await form.validateFields();

    try {
      dispatch(appLoaderAction.enable());

      // dispatch(templateContentPreviewAction.addTemplateContent(getSaveBeanByTemplateType(values).bean));
      const saveBean = getSaveBeanByTemplateType(values).bean;
      // console.log(saveBean);
      await openWebsitePreview({
        type: PREVIEW_TYPE.content,
        bean: saveBean,
        path: (token) => `/content/${saveBean.templateId ? saveBean.templateId : token}`,
      });
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };
  /**common end**/

  /**template content1 start**/
  function getSaveBeanContent1(values) {
    let mainTitle = { titleTH: mainTitleTH, titleEN: mainTitleEN };
    let title = { titleTH: titleTH, titleEN: titleEN };
    let content = { contentTH: editorContentTH, contentEN: editorContentEN };
    let attachImage = bannerList.map((x) => {
      return x.response.bean;
    });
    let newDocumentList = documentList.map((x) => {
      return x.response.bean;
    });
    let facebookLink = facebookLinkValue;

    if (!editData) {
      let bean = {
        templateType: templateType,
        mainTitle: mainTitle,
        content: [
          {
            title: title,
            attachImage: attachImage,
            content: content,
            documentList: newDocumentList,
            keywordList: keywordList,
            facebookLink: facebookLink,
          },
        ],
        urlSuffix: values.urlSuffix,
      };

      return { bean: bean };
    } else {
      let bean = JSON.parse(JSON.stringify(editData));
      bean.templateType = templateType;
      bean.mainTitle.titleTH = mainTitleTH;
      bean.mainTitle.titleEN = mainTitleEN;
      bean.content = [
        {
          title: title,
          attachImage: attachImage,
          content: content,
          documentList: newDocumentList,
          keywordList: keywordList,
          facebookLink: facebookLink,
        },
      ];
      bean.urlSuffix = values.urlSuffix;
      return { bean: bean };
    }
  }

  const onChangeUploadImageHeaderTemplate1 = ({ fileList }) => {
    setBannerList(fileUtils.composeUrlInFileList(fileList));
  };

  const onChangeUploadDocumentTemplate1 = ({ fileList }) => {
    setDocumentList(fileUtils.composeUrlInFileList(fileList));
  };

  const onChangeValueTH = (value) => {
    setEditorContentTH(value);
  };

  const onChangeValueEN = (value) => {
    setEditorContentEN(value);
  };

  const renderContent1TemplateMain = () => {
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="ภาษาไทย" key={langTH}>
            {renderTabTamplateContent1(langTH)}
          </TabPane>
          <TabPane tab="English" key={langEN}>
            {renderTabTamplateContent1(langEN)}
          </TabPane>
        </Tabs>

        <Form.Item label="รูปภาพ" valuePropName="fileList" name="bannerList">
          <UploadImage
            listType="picture-card"
            accept={fileTYPE_IMG}
            onChange={onChangeUploadImageHeaderTemplate1}
            fileList={bannerList}
          >
            {templateType === 0
              ? bannerList.length >= 5
                ? null
                : uploadButton
              : bannerList.length >= 1
              ? null
              : uploadButton}
          </UploadImage>
          {templateType === 0 ? (
            <label className="text-danger">
              * ขนาดรูปภาพที่แนะนำคือ 930x430 pixels.
            </label>
          ) : (
            <label className="text-danger">
              * ขนาดรูปภาพที่แนะนำคือ 1600x293 pixels.
            </label>
          )}
        </Form.Item>

        <Form.Item label="Facebook Link" key="facebookLink">
          <Input
            className="mb-4 pb-1"
            value={facebookLinkValue}
            onChange={onChagneFacebookLink}
          />
        </Form.Item>

        <Form.Item label="เอกสาร" valuePropName="fileList" name="documentList">
          <UploadFile
            {...props}
            fileList={documentList}
            accept={fileTYPE_DOCUMENT}
            onChange={onChangeUploadDocumentTemplate1}
          >
            <Button type="dashed" icon={<UploadOutlined />}>
              {"อัปโหลดไฟล์"}
            </Button>
          </UploadFile>

          {documentList
            ? documentList.map((file) => {
                return (
                  <div>
                    <a
                      href={fileUtils.getFileRenderUrl(
                        groupType.TEMPLATE,
                        editData ? editData.templateId : null,
                        file.originalFilename
                      )}
                      download
                    >
                      {file.originalFilename}
                    </a>
                  </div>
                );
              })
            : "อัปโหลดไฟล์"}
        </Form.Item>
      </div>
    );
  };

  const renderTabTamplateContent1 = (lang) => {
    return (
      <div className="bg-grey py-4">
        <Divider orientation="left" plain>
          <h5 className="color-primary-title mb-0">
            {lang === langTH ? "เนื้อหา" : "Content"}
          </h5>
        </Divider>

        {renderMainTitle(lang)}

        <Form
          layout="vertical"
          name="add_edit_template_content"
          preserve={false}
          form={form}
          initialValues={{
            status: true,
          }}
        >
          <Form.Item
            name={lang === langTH ? "titleTH" : "titleEN"}
            label={lang === langTH ? "ชื่อเนื้อหา" : "Title"}
            key={lang === langTH ? "titleTH" : "titleEN"}
            rules={
              lang === langTH
                ? [
                    {
                      required: true,
                    },
                  ]
                : [
                    {
                      required: false,
                    },
                  ]
            }
          >
            {lang === langTH ? (
              <Input
                className="mb-4 pb-1"
                value={titleTH}
                onChange={onChagneTitleTH}
              />
            ) : (
              <Input
                className="mb-4 pb-1"
                value={titleEN}
                onChange={onChagneTitleEN}
              />
            )}
          </Form.Item>
        </Form>

        <div>
          {/* NMU-460: the content form drops the gallery pickers — the editor
              sits directly under the section title. */}
          <h3>{lang === langTH ? "รายละเอียดเนื้อหา" : "Content"}</h3>
          {lang === langTH ? (
            <HtmlEditor
              showGalleryButtons={false}
              setContents={editorContentTH}
              onChange={onChangeValueTH}
            />
          ) : (
            <HtmlEditor
              showGalleryButtons={false}
              setContents={editorContentEN}
              onChange={onChangeValueEN}
            />
          )}
        </div>
      </div>
    );
  };
  /**template content1 end**/

  /**template grid content start**/
  function getSaveBeanGridContent(values) {
    let mainTitle = { titleTH: mainTitleTH, titleEN: mainTitleEN };
    /*
      NMU-592: each sub-item states where it sits.

      The order already survived on its own — the array is sent in order and
      Mongo keeps a list as an array — but it was only ever implied by position.
      Sending it makes the payload say what the author arranged, so a reorder is
      a visible change in the request rather than something a reader has to
      infer. The server stamps the same value from the same list on the way in,
      so the two cannot drift.
    */
    let newItemList = withDisplayOrder(itemList).map((item) => {
      return {
        ...item,
        documentList: item.documentList.map((doc) => {
          return doc.response.bean;
        }),
        keywordList: keywordList,
        facebookLink: item.facebookLink,
      };
    });

    if (!editData) {
      let bean = {
        templateType: templateType,
        mainTitle: mainTitle,
        content: newItemList,
        urlSuffix: values.urlSuffix,
      };
      return { bean: bean };
    } else {
      let bean = JSON.parse(JSON.stringify(editData));
      bean.templateType = templateType;
      bean.mainTitle.titleTH = mainTitleTH;
      bean.mainTitle.titleEN = mainTitleEN;
      bean.content = newItemList;
      bean.urlSuffix = values.urlSuffix;
      return { bean: bean };
    }
  }

  const renderGridTemplateMain = () => {
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="ภาษาไทย" key={"Grid" + langTH}>
            {renderMainTitle(langTH)}
          </TabPane>
          <TabPane tab="English" key={"Grid" + langEN}>
            {renderMainTitle(langEN)}
          </TabPane>
        </Tabs>

        {renderGridContentTemplateDetail()}

        <div className="text-right mt-3">
          <Button type="primary" className="me-2" onClick={onAddItem}>
            <Icon.Plus className="me-1" size={18} />
          </Button>
        </div>
      </div>
    );
  };

  /**
   * NMU-592: a sub-item's React identity, so a move moves the component with it.
   *
   * Keying by array index would tie each rendered panel to a position rather
   * than to an item: after a move React would keep the panel where it was and
   * hand it the other item's props, which is how a rich-text editor ends up
   * showing the body it had before the move. A saved item already has a stable
   * id from the server, so that is used.
   *
   * A newly added item has none until it is saved, and falls back to its index.
   * That is sound here rather than a gap: the fields it holds are all rendered
   * from `itemList` — the editor takes its body through `setContents` — so they
   * follow the data either way. The key only decides whether the panel is moved
   * or re-rendered in place.
   */
  const itemKey = (item, index) =>
    item && item.contentId ? "gridcontent-" + item.contentId : "gridcontent-new-" + index;

  const renderGridContentTemplateDetail = () => {
    return itemList.map((item, index) => {
      const {
        title,
        attachImage,
        documentList,
        content,
        description,
        facebookLink,
      } = item;
      return (
        <div key={itemKey(item, index)}>
          {/*
            NMU-592: the reorder controls.

            Up/down buttons rather than drag and drop (the ticket offers
            either). This form is a modal of stacked tab panels holding rich
            text editors and upload widgets; a drag layer over that has to win
            against the editor's own mouse handling, and it gives keyboard and
            touch users nothing. Two buttons work with a keyboard, are
            unambiguous on a phone, and are testable without simulating a drag.
          */}
          <div className="d-flex align-items-center justify-content-end mb-2">
            <span className="me-2 text-muted">{"ลำดับที่ " + (index + 1) + " จาก " + itemList.length}</span>
            <Button
              className="me-1"
              style={{ minWidth: 30 }}
              disabled={index === 0}
              title="เลื่อนขึ้น"
              aria-label={"เลื่อนรายการที่ " + (index + 1) + " ขึ้น"}
              data-testid={"grid-move-up-" + index}
              onClick={onMoveItem(index, -1)}
            >
              <Icon.ArrowUp size={18} />
            </Button>
            <Button
              style={{ minWidth: 30 }}
              disabled={index === itemList.length - 1}
              title="เลื่อนลง"
              aria-label={"เลื่อนรายการที่ " + (index + 1) + " ลง"}
              data-testid={"grid-move-down-" + index}
              onClick={onMoveItem(index, 1)}
            >
              <Icon.ArrowDown size={18} />
            </Button>
          </div>
          <div>
            <Tabs defaultActiveKey="1">
              <TabPane tab="ภาษาไทย" key={index + langTH}>
                <Divider orientation="left" plain>
                  <h5 className="color-primary-title mb-0">
                    {"รายการที่ " + (index + 1)}
                  </h5>
                </Divider>
                {renderTabGridContent(
                  langTH,
                  index,
                  content,
                  title,
                  description
                )}
              </TabPane>
              <TabPane tab="English" key={index + langEN}>
                <Divider orientation="left" plain>
                  <h5 className="color-primary-title mb-0">
                    {"Content List " + (index + 1)}
                  </h5>
                </Divider>
                {renderTabGridContent(
                  langEN,
                  index,
                  content,
                  title,
                  description
                )}
              </TabPane>
            </Tabs>

            <Form.Item
              label="รูปภาพ"
              valuePropName="fileList"
              name={"attachImage" + index}
            >
              <UploadImage
                listType="picture-card"
                showUploadList={false}
                accept={fileTYPE_IMG}
                onChange={onChangeImageGridContent(index)}
              >
                {attachImage[0] ? (
                  <img
                    src={
                      attachImage[0].tempFilename
                        ? fileUtils.getTempFileRenderUrl(
                            attachImage[0].tempFilename,
                            attachImage[0].type
                          )
                        : fileUtils.getFileRenderUrl(
                            groupType.TEMPLATE,
                            editData ? editData.templateId : null,
                            attachImage[0].originalFilename
                          )
                    }
                    alt="avatar"
                    style={{ width: "100%" }}
                  />
                ) : (
                  "อัปโหลดไฟล์"
                )}
              </UploadImage>
              <label className="text-danger">
                * ขนาดรูปภาพที่แนะนำคือ 930x430 pixels.
              </label>
            </Form.Item>

            <Form.Item label="Facebook Link" key="facebookLink">
              <Input
                className="mb-4 pb-1"
                value={facebookLink}
                onChange={({ target }) =>
                  onChangeFacebookLinkGridContent(index)(target.value)
                }
              />
            </Form.Item>

            <UploadFile
              {...props}
              accept={fileTYPE_DOCUMENT}
              fileList={documentList}
              onChange={onChangeDocumentGridContent(index)}
            >
              <Button type="dashed" icon={<UploadOutlined />}>
                {"อัปโหลดไฟล์"}
              </Button>
            </UploadFile>
          </div>

          <div className="text-right mt-3">
            <Button
              key={"submit" + index}
              type="danger"
              className="me-2"
              style={{ minWidth: 30 }}
              onClick={onRemoveItem(index)}
            >
              <Icon.Trash size={18} />
            </Button>
          </div>
        </div>
      );
    });
  };

  const renderTabGridContent = (lang, index, content, title, description) => {
    return (
      <div>
        <Form.Item
          key={(lang === langTH ? "title.titleTH" : "title.titleEN") + index}
          rules={
            lang === langTH
              ? [
                  {
                    required: true,
                  },
                ]
              : [
                  {
                    required: false,
                  },
                ]
          }
        >
          <span>{lang === langTH ? "ชื่อเนื้อหา" : "Title"}</span>{" "}
          <span class="red-star">{lang === langTH ? "*" : ""}</span>
          {lang === langTH ? (
            <Input
              type="text"
              className="mb-4 pb-1"
              value={title.titleTH}
              onChange={({ target }) =>
                onChangeTitle(index, lang)(target.value)
              }
            />
          ) : (
            <Input
              type="text"
              className="mb-4 pb-1"
              value={title.titleEN}
              onChange={({ target }) =>
                onChangeTitle(index, lang)(target.value)
              }
            />
          )}
        </Form.Item>

        <Form.Item
          key={(lang === langTH ? "descriptionTH" : "descriptionEN") + index}
          rules={
            lang === langTH
              ? [
                  {
                    required: true,
                  },
                ]
              : [
                  {
                    required: false,
                  },
                ]
          }
        >
          <span>{lang === langTH ? "คำอธิบาย" : "DescriptionTitle"}</span>{" "}
          <span class="red-star">{lang === langTH ? "*" : ""}</span>
          {lang === langTH ? (
            <Input
              className="mb-4 pb-1"
              value={description.descriptionTH}
              onChange={({ target }) =>
                onChangeDescription(index, lang)(target.value)
              }
            />
          ) : (
            <Input
              className="mb-4 pb-1"
              value={description.descriptionEN}
              onChange={({ target }) =>
                onChangeDescription(index, lang)(target.value)
              }
            />
          )}
        </Form.Item>

        {/* NMU-460: same removal for the grid-content item editors. */}
        <h3>{lang === langTH ? "รายละเอียดเนื้อหา" : "Content"}</h3>
        {lang === langTH ? (
          <HtmlEditor
            showGalleryButtons={false}
            setContents={content.contentTH}
            onChange={(value) => {
              onChangeContent(index, lang, value);
            }}
          />
        ) : (
          <HtmlEditor
            showGalleryButtons={false}
            setContents={content.contentEN}
            onChange={(value) => {
              onChangeContent(index, lang, value);
            }}
          />
        )}
      </div>
    );
  };

  const onChangeImageGridContent = (index) => {
    return ({ file }) => {
      if (file.status === "done") {
        const { bean } = file.response;
        const newList = [...itemList];
        newList[index].attachImage = [bean];
        setItemList(newList);
      }
    };
  };

  const onChangeDocumentGridContent = (index) => {
    return ({ fileList }) => {
      const newList = [...itemList];
      newList[index].documentList = fileUtils.composeUrlInFileList(fileList);
      setItemList(newList);
    };
  };

  // ???? Top Tabs ????
  const [panes, setPanes] = useState([]);
  const [activeKey, setActiveKey] = useState();
  const [leftActiveKey, setLeftActiveKey] = useState();

  function getSaveBeanMultiTabContent(values) {
    let mainTitle = { titleTH: mainTitleTH, titleEN: mainTitleEN };
    let newItemList = panes.map((item) => {
      return {
        ...item,
        keywordList: keywordList,
      };
    });

    if (!editData) {
      let bean = {
        templateType: templateType,
        mainTitle: mainTitle,
        content: newItemList,
        urlSuffix: values.urlSuffix,
      };
      return { bean: bean };
    } else {
      let bean = JSON.parse(JSON.stringify(editData));
      bean.templateType = templateType;
      bean.mainTitle.titleTH = mainTitleTH;
      bean.mainTitle.titleEN = mainTitleEN;
      bean.content = newItemList;
      bean.urlSuffix = values.urlSuffix;
      return { bean: bean };
    }
  }

  /**
   * NMU-458: a "dynamic listing" format (Programs) has no content blocks — the
   * page body is rendered from another module, so the only thing the editor
   * supplies is the main title. Saved with an empty `content` so the bean stays
   * the same shape as every other template.
   */
  function getSaveBeanDynamicListing(values) {
    let mainTitle = { titleTH: mainTitleTH, titleEN: mainTitleEN };

    if (!editData) {
      return {
        bean: {
          templateType: templateType,
          mainTitle: mainTitle,
          content: [],
          urlSuffix: values.urlSuffix,
        },
      };
    }

    let bean = JSON.parse(JSON.stringify(editData));
    bean.templateType = templateType;
    bean.mainTitle.titleTH = mainTitleTH;
    bean.mainTitle.titleEN = mainTitleEN;
    bean.content = [];
    bean.urlSuffix = values.urlSuffix;
    return { bean: bean };
  }

  /** NMU-458: the main title, plus a note saying where the body comes from. */
  const renderDynamicListingTemplate = (noteTH) => {
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="ภาษาไทย" key={"Listing" + langTH}>
            {renderMainTitle(langTH)}
          </TabPane>
          <TabPane tab="English" key={"Listing" + langEN}>
            {renderMainTitle(langEN)}
          </TabPane>
        </Tabs>

        <div className="mt-2 p-3" style={{ background: "#f6f6f6", borderRadius: 6 }}>
          <Icon.Info className="me-2" size={16} style={{ verticalAlign: "text-bottom" }} />
          <span data-testid="dynamic-listing-note">{noteTH}</span>
        </div>
      </div>
    );
  };

  function validateDynamicListing() {
    if (!DYNAMIC_LISTING_TYPES.includes(templateType)) {
      return true;
    }
    if (!mainTitleTH) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุชื่อเนื้อหาหลักให้ครบถ้วน");
      return false;
    }
    return true;
  }

  const onTabNameChange = (event) => {
    const updatedPanes = panes.map((pane) =>
      pane.key === activeKey
        ? {
            ...pane,
            title: {
              ...pane?.title,
              [event.target.name]: event.target.value,
            },
          }
        : pane
    );
    setPanes(updatedPanes);
  };

  const onLeftTabNameChange = (event) => {
    const indexMainTab = panes.findIndex((item) => item.key === activeKey);
    const indexChildTab = panes[indexMainTab].crosstabDetailList.findIndex(
      (item) => item.key === leftActiveKey
    );

    const newMainTab = [...panes];

    const currentChildTab = {
      ...panes[indexMainTab].crosstabDetailList[indexChildTab],
    };
    //console.log('currentChildTab', currentChildTab);
    currentChildTab.title = {
      ...currentChildTab?.title,
      [event.target.name]: event.target.value,
    };

    newMainTab[indexMainTab].crosstabDetailList[indexChildTab] =
      currentChildTab;

    setPanes(newMainTab);
  };

  const onMainTabChange = (key) => {
    //console.log('tab key', key);
    const mainTabIndex = panes.findIndex((item) => item.key === key);
    const indexTab = panes[mainTabIndex];

    setActiveKey(key);
    form.setFieldsValue({
      titleTH: indexTab?.title.titleTH,
      titleEN: indexTab?.title.titleEN,
    });
    //form.resetFields(["mainTabTitle"]);
  };

  const onLeftTabChange = (key) => {
    //console.log('child tab key', key);
    setLeftActiveKey(key);

    const mainTabIndex = panes.findIndex((item) => item.key === activeKey);
    const indexChildTab = panes[mainTabIndex].crosstabDetailList.findIndex(
      (item) => item.key === key
    );

    const childTab = panes[mainTabIndex].crosstabDetailList[indexChildTab];
    form.setFieldsValue({
      childTitleTH: childTab?.title.titleTH,
      childTitleEN: childTab?.title.titleEN,
    });
  };

  useEffect(() => {
    const activePane = panes.find((pane) => pane.key === activeKey);
    if (activePane && activePane.title.titleTH) {
      form.setFieldsValue({
        titleTH: activePane.title.titleTH,
        titleEN: activePane.title.titleEN,
      });
    }
  }, [activeKey, panes, form]);

  useEffect(() => {
    const activePane = panes.find((pane) => pane.key === activeKey);
    // console.log(activePane);
    const leftActivePane = activePane?.crosstabDetailList.find(
      (item) => item.key === leftActiveKey
    );
    if (leftActivePane && leftActivePane.title.titleTH) {
      form.setFieldsValue({
        childTitleTH: leftActivePane.title.titleTH,
        childTitleEN: leftActivePane.title.titleEN,
      });
    }
  }, [form, leftActiveKey, panes, activeKey]);

  const onAddCrossTabDetailContent = (e) => {
    e.preventDefault();
    const newMainTab = [...panes];
    const mainIndex = newMainTab.findIndex((item) => item.key === activeKey);
    const childIndex = newMainTab[mainIndex].crosstabDetailList.findIndex(
      (item) => item.key === leftActiveKey
    );
    const lastDetailList =
      newMainTab[mainIndex]?.crosstabDetailList[childIndex].linkDetailList;
    const newList = lastDetailList ? [...lastDetailList] : [];
    // console.log("lastDetailList : ", lastDetailList);
    //const newList = [...crosstabDetailList];
    newList.push({
      key: lastDetailList.length,
      title: {
        titleTH: "",
        titleEN: "",
      },
      link: "",
      detailTH: "",
      detailEN: "",
    });

    newMainTab[mainIndex].crosstabDetailList[childIndex].linkDetailList =
      newList;
    setPanes(newMainTab);

    //setCrosstabDetailList(newList);
  };

  const onRemoveCrossTabContent = (index) => {
    const newMainTab = [...panes];
    const mainIndex = newMainTab.findIndex((item) => item.key === activeKey);
    const childIndex = newMainTab[mainIndex].crosstabDetailList.findIndex(
      (item) => item.key === leftActiveKey
    );
    const lastDetailList =
      newMainTab[mainIndex]?.crosstabDetailList[childIndex].linkDetailList;
    const detailList = lastDetailList ? [...lastDetailList] : [];

    const newList = detailList.filter((item) => item.key !== index);

    newMainTab[mainIndex].crosstabDetailList[childIndex].linkDetailList =
      newList;
    setPanes(newMainTab);
  };

  const onChangeTitleContent = (detail, event) => {
    const newMainTab = [...panes];
    const indexMainTab = newMainTab.findIndex((item) => item.key === activeKey);
    const indexChildTab = newMainTab[indexMainTab].crosstabDetailList.findIndex(
      (item) => item.key === leftActiveKey
    );

    const indexLinkList = newMainTab[indexMainTab]?.crosstabDetailList[
      indexChildTab
    ].linkDetailList.findIndex((item) => item.key === detail.key);

    const detailData = {
      ...newMainTab[indexMainTab]?.crosstabDetailList[indexChildTab]
        .linkDetailList[indexLinkList],
    };

    detailData.title = {
      ...detailData?.title,
      [event.target.name]: event.target.value,
    };
    //
    newMainTab[indexMainTab].crosstabDetailList[indexChildTab].linkDetailList[
      indexLinkList
    ] = detailData;

    setPanes(newMainTab);
    //
  };

  const onChangeLinkContentDetail = (detail, value, name) => {
    console.log(detail, " || ", value, " || ", name);
    const newMainTab = [...panes];
    const indexMainTab = newMainTab.findIndex((item) => item.key === activeKey);
    const indexChildTab = newMainTab[indexMainTab].crosstabDetailList.findIndex(
      (item) => item.key === leftActiveKey
    );

    const indexLinkList = newMainTab[indexMainTab]?.crosstabDetailList[
      indexChildTab
    ].linkDetailList.findIndex((item) => item.key === detail.key);

    const detailData = {
      ...newMainTab[indexMainTab]?.crosstabDetailList[indexChildTab]
        .linkDetailList[indexLinkList],
    };

    detailData.detail = {
      ...detailData?.detail,
      [name]: value,
    };
    //
    newMainTab[indexMainTab].crosstabDetailList[indexChildTab].linkDetailList[
      indexLinkList
    ] = detailData;

    setPanes(newMainTab);
    //
  };

  const onChangeLinkContent = (detail, event) => {
    const newMainTab = [...panes];
    const indexMainTab = newMainTab.findIndex((item) => item.key === activeKey);
    const indexChildTab = newMainTab[indexMainTab].crosstabDetailList.findIndex(
      (item) => item.key === leftActiveKey
    );

    const indexLinkList = newMainTab[indexMainTab]?.crosstabDetailList[
      indexChildTab
    ].linkDetailList.findIndex((item) => item.key === detail.key);

    let detailData = {
      ...newMainTab[indexMainTab]?.crosstabDetailList[indexChildTab]
        .linkDetailList[indexLinkList],
    };

    detailData = { ...detailData, [event.target.name]: event.target.value };
    //
    newMainTab[indexMainTab].crosstabDetailList[indexChildTab].linkDetailList[
      indexLinkList
    ] = detailData;

    setPanes(newMainTab);
    //
  };

  const add = () => {
    const newActiveKey = `newTab${panes.length}`;
    const newPane = {
      title: { titleTH: "New Tab", titleEN: "" },
      key: newActiveKey,
      crosstabDetailList: [],
    };
    setPanes([...panes, newPane]);
    setActiveKey(newActiveKey);
    form.resetFields(["childTitleTH", "childTitleEN"]);
  };

  const addLeftTab = () => {
    const newMainTabs = [...panes];
    const mainTabIndex = panes.findIndex((item) => item.key === activeKey);
    const childs = newMainTabs[mainTabIndex].crosstabDetailList;

    const newActiveKey = `newTab${childs.length}`;

    const newChildTab = {
      title: { titleTH: "New Tab", titleEN: "" },
      key: newActiveKey,
      linkDetailList: [],
    };

    childs.push(newChildTab);

    setPanes(newMainTabs);
    setLeftActiveKey(newActiveKey);
  };

  const onEdit = (targetKey, action) => {
    if (action === "add") {
      add();
    } else {
      remove(targetKey, "topTab");
    }
  };

  const onEditLeftTab = (targetKey, action) => {
    if (action === "add") {
      addLeftTab();
    } else {
      remove(targetKey, "leftTab");
    }
  };

  const remove = (targetKey, tabKey) => {
    if (tabKey !== "leftTab") {
      let newActiveKey = activeKey;
      const newMainTab = [...panes].filter((item, index) => {
        const isRemove = item.key === targetKey;
        if (isRemove && newActiveKey === item.key) {
          newActiveKey = index === 0 ? panes[1].key : panes[index - 1].key;
        }
        return !isRemove;
      });

      setActiveKey(newActiveKey);
      setPanes(newMainTab);
      return;
    }

    const newMainTabs = [...panes];
    const mainTabIndex = newMainTabs.findIndex(
      (item) => item.key === activeKey
    );

    const mainTab = newMainTabs[mainTabIndex];
    let newChildActiveKey = leftActiveKey;
    const newChilds = [...mainTab.crosstabDetailList].filter((item, index) => {
      const isRemove = item.key === targetKey;
      if (isRemove && newChildActiveKey === item.key) {
        newChildActiveKey =
          index === 0
            ? mainTab.crosstabDetailList[1].key
            : mainTab.crosstabDetailList[index - 1].key;
      }
      return !isRemove;
    });
    mainTab.crosstabDetailList = newChilds;

    setLeftActiveKey(newChildActiveKey);
    setPanes(newMainTabs);

    // const filteredPanes = tabKey === "leftTab" ? leftPanes : panes;
    // let newActiveKey = activeKey;
    // let lastIndex;

    // filteredPanes.forEach((pane, i) => {
    //   if (pane.key === targetKey) {
    //     lastIndex = i - 1;
    //   }
    // });

    // const newPanes = filteredPanes.filter((pane) => pane.key !== targetKey);
    // if (newPanes.length && newActiveKey === targetKey) {
    //   if (lastIndex >= 0) {
    //     newActiveKey = newPanes[lastIndex].key;
    //   } else {
    //     newActiveKey = newPanes[0].key;
    //   }
    // }

    // if (tabKey === "leftTab") {
    //   setLeftActiveKey(newActiveKey);
    //   setLeftPanes(newPanes);
    // } else {
    //   setActiveKey(newActiveKey);
    //   setPanes(newPanes);
    // }
  };

  const renderLeftTabContent = (detailList) => {
    if (!detailList) {
      return null;
    }
    return detailList.map((detail, index) => (
      <div key={"crosstabContent" + index} className="px-4">
        <h5 className="color-primary-title mb-0">
          {"รายการที่ " + (index + 1)}
        </h5>
        <Col className="mt-4">
          <Form.Item
            label={"ชื่อหัวข้อ"}
            key={"crosstabContentTitleTH"}
            initialValue={detail?.title?.titleTH}
            required
          >
            <Input
              name={"titleTH"}
              value={detail?.title?.titleTH}
              onChange={(e) => onChangeTitleContent(detail, e)}
              maxLength={150}
            />
          </Form.Item>
          <Form.Item
            label={"Title Name"}
            key={"crosstabContentTitleEN"}
            initialValue={detail?.title?.titleEN}
          >
            <Input
              name={"titleEN"}
              value={detail?.title?.titleEN}
              onChange={(e) => onChangeTitleContent(detail, e)}
              maxLength={150}
            />
          </Form.Item>
          <Form.Item
            label={"ลิงค์"}
            key={"crosstabContentLink"}
            initialValue={detail.link}
          >
            <Input
              name={"link"}
              value={detail.link}
              onChange={(e) => onChangeLinkContent(detail, e)}
            />
          </Form.Item>
          <Form.Item
            label={"รายละเอียด"}
            key={"crosstabContentDetailTH"}
            initialValue={detail?.detail?.detailTH}
          >
            <SunEditor
              setContents={detail?.detail?.detailTH}
              setOptions={{
                height: 150,
                imageFileInput: false,
                buttonList: [["link"]],
              }}
              onChange={(e) => onChangeLinkContentDetail(detail, e, "detailTH")}
            />
            {/* <Input
              name={"detailTH"}
              value={detail?.detail?.detailTH}
              onChange={(e) => onChangeLinkContentDetail(detail, e)}
            /> */}
          </Form.Item>
          <Form.Item
            label={"Detail"}
            key={"crosstabContentDetailEN"}
            initialValue={detail?.detail?.detailEN}
          >
            <SunEditor
              setContents={detail?.detail?.detailEN}
              setOptions={{
                height: 150,
                imageFileInput: false,
                buttonList: [["link"]],
              }}
              onChange={(e) => onChangeLinkContentDetail(detail, e, "detailEN")}
            />
          </Form.Item>
          {/* <Row align="center" justify="space-between">
            <Col span={4}>ชื่อหัวข้อ</Col>
            <Col span={20}>
              <Input
                className="mb-4 pb-1"
                name={"titleTH"}
                value={detail?.title?.titleTH}
                onChange={(e) => onChangeTitleContent(detail, e)}
                maxLength={150}
              />
            </Col>
          </Row>
          <Row align="center" justify="space-between">
            <Col span={4}>Title Name</Col>
            <Col span={20}>
              <Input
                className="mb-4 pb-1"
                name={"titleEN"}
                value={detail?.title?.titleEN}
                onChange={(e) => onChangeTitleContent(detail, e)}
                maxLength={150}
              />
            </Col>
          </Row>
          <Row align="center" justify="space-between">
            <Col span={4}>ลิงค์</Col>
            <Col span={20}>
              <Input
                className="mb-4 pb-1"
                name={"link"}
                value={detail.link}
                onChange={(e) => onChangeLinkContent(detail, e)}
              />
            </Col>
          </Row>
          <Row align="center" justify="space-between">
            <Col span={4}>
              <p>รายละเอียด</p>
            </Col>
            <Col span={20}>
              <Input
                className="mb-4 pb-1 w-max"
                name={"detailTH"}
                value={detail?.detail?.detailTH}
                onChange={(e) => onChangeLinkContentDetail(detail, e)}
              />
            </Col>
          </Row>
          <Row align="center" justify="space-between">
            <Col span={4}>
              <p>Detail</p>
            </Col>
            <Col span={20}>
              <Input
                className="mb-4 pb-1 w-max"
                name={"detailEN"}
                value={detail?.detail?.detailEN}
                onChange={(e) => onChangeLinkContentDetail(detail, e)}
              />
            </Col>
          </Row> */}
          <div className="text-right mt-3">
            <Button
              key={"submit" + index}
              type="danger"
              className="me-2"
              style={{ minWidth: 30 }}
              onClick={() => onRemoveCrossTabContent(detail.key)}
            >
              <Icon.Trash size={18} />
            </Button>
          </div>
          <Divider />
        </Col>
      </div>
    ));
  };

  const renderMultiTabContent = () => {
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="ภาษาไทย" key={"Grid" + langTH}>
            {renderMainTitle(langTH)}
          </TabPane>
          <TabPane tab="English" key={"Grid" + langEN}>
            {renderMainTitle(langEN)}
          </TabPane>
        </Tabs>
        <div>
          <Form
            layout="vertical"
            name="add_edit_template_content"
            preserve={false}
            form={form}
            initialValues={{
              status: true,
            }}
          >
            <Tabs
              type="editable-card"
              onChange={onMainTabChange}
              activeKey={activeKey}
              onEdit={onEdit}
            >
              {panes.map((pane) => (
                <TabPane
                  // tab={pane.title.titleTH}
                  tab={
                    <div
                      style={{
                        maxWidth: 150,
                        overflow: "hidden",
                        display: "inline-block",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {pane.title.titleTH}
                    </div>
                  }
                  key={pane.key}
                  closable={pane.closable}
                >
                  {/* {pane.content} */}

                  {/* <Form.Item
                    name={"mainTabTitle"}
                    label={"ชื่อแท็บหลัก"}
                    key={"mainTabTitle"}
                    initialValue={pane.title.titleTH}
                    required
                  >
                    <Input value={tabName} onChange={onTabNameChange} />
                  </Form.Item> */}
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name={"titleTH"}
                        label={"ชื่อแท็บหลัก"}
                        key={"mainTabTitleTH"}
                        required
                      >
                        <Input
                          name={"titleTH"}
                          onChange={onTabNameChange}
                          maxLength={150}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        name={"titleEN"}
                        label={"Main Tab Name"}
                        key={"mainTabTitleEN"}
                      >
                        <Input
                          name={"titleEN"}
                          onChange={onTabNameChange}
                          maxLength={150}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Divider orientation="left" plain>
                    <h5 className="color-primary-title mb-0">เนื้อหา</h5>
                  </Divider>
                  <Row gutter={16}>
                    <Col span={6}>
                      <Button
                        type="primary"
                        className="w-100"
                        size={40}
                        onClick={addLeftTab}
                      >
                        <Icon.Plus className="me-1" size={18} /> เพิ่มเมนู
                      </Button>
                    </Col>
                  </Row>

                  <Tabs
                    hideAdd
                    type="editable-card"
                    onChange={onLeftTabChange}
                    activeKey={leftActiveKey}
                    onEdit={onEditLeftTab}
                    tabPosition="left"
                    className="mt-4"
                    style={{ height: 600 }}
                  >
                    {pane.crosstabDetailList?.map((item, index) => (
                      <TabPane
                        tab={
                          <div
                            style={{
                              width: 150,
                              overflow: "hidden",
                              display: "inline-block",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.title.titleTH}
                          </div>
                        }
                        // tab={item.title.titleTH}
                        key={item.key}
                        closable={item.closable}
                      >
                        <Form.Item
                          name={"childTitleTH"}
                          label={"ชื่อแท็บเมนู"}
                          key={"leftTabTitleTH"}
                          initialValue={item.title.titleTH}
                          required
                        >
                          <Input
                            name={"titleTH"}
                            value={item.title.titleTH}
                            onChange={onLeftTabNameChange}
                            maxLength={150}
                          />
                        </Form.Item>
                        <Form.Item
                          name={"childTitleEN"}
                          label={"Sub Tab Name"}
                          key={"leftTabTitleEN"}
                          initialValue={item.title.titleEN}
                        >
                          <Input
                            className="mb-4 "
                            name={"titleEN"}
                            value={item.title.titleEN}
                            onChange={onLeftTabNameChange}
                            maxLength={150}
                          />
                        </Form.Item>
                        <div className="text-right my-3">
                          <Button
                            type="primary"
                            className="me-2"
                            onClick={onAddCrossTabDetailContent}
                          >
                            <Icon.Plus className="me-1" size={18} />
                          </Button>
                        </div>
                        <div style={{ height: "300px", overflowY: "auto" }}>
                          {renderLeftTabContent(item.linkDetailList)}
                        </div>
                      </TabPane>
                    ))}
                  </Tabs>
                </TabPane>
              ))}
            </Tabs>
          </Form>
        </div>
        {/* {renderGridContentTemplateDetail()} */}

        {/* <div className="text-right mt-3">
          <Button type="primary" className="me-2" onClick={onAddItem}>
            <Icon.Plus className="me-1" size={18} />
          </Button>
        </div> */}
      </div>
    );
  };

  // const onChangeFacebookLinkGridContent = (index) => {
  //   console.log('onchange ', index);
  //   return ({facebookLink}) =>{
  //     console.log('onchange ', facebookLink);
  //     const newList = [...itemList];
  //     newList[index]. = facebookLink;
  //     setItemList(newList);
  //   }
  // };

  const onChangeFacebookLinkGridContent = (index) => {
    return (value) => {
      const newList = [...itemList];
      newList[index].facebookLink = value;
      setItemList(newList);
    };
  };

  const onAddItem = (e) => {
    e.preventDefault();
    const newList = [...itemList];
    newList.push({
      attachImage: [],
      documentList: [],
      title: { titleTH: null, titleEN: null },
      content: { contentTH: null, contentEN: null },
      description: { descriptionTH: null, descriptionEN: null },
    });
    setItemList(newList);
  };

  const onRemoveItem = (index) => {
    return () => {
      const newList = [...itemList];
      newList.splice(index, 1);
      setItemList(newList);
    };
  };

  /**
   * NMU-592: move a sub-item up or down the page.
   *
   * The whole item object changes position — it is not a field-by-field copy —
   * so the title, description, body, image and documents travel with it and
   * nothing has to be re-entered. That is the requirement that makes the naive
   * implementation wrong: swapping only the visible fields leaves an item's
   * uploaded image behind on the item it was swapped with.
   *
   * The "รายการที่ N" headings are rendered from the array index, so they
   * renumber themselves once the array changes; there is no separate label
   * state that could disagree with the order.
   */
  const onMoveItem = (index, offset) => {
    return () => {
      const newList = moveItem(itemList, index, offset);
      if (newList !== itemList) {
        setItemList(newList);
      }
    };
  };

  const onChangeContent = (index, lang, value) => {
    setItemList((list) => {
      let newList = [...list];
      if (lang === langTH) {
        newList[index].content.contentTH = value;
      } else {
        newList[index].content.contentEN = value;
      }
      return list;
    });
  };

  const onChangeTitle = (index, lang) => {
    return (value) => {
      const newList = [...itemList];
      if (lang === langTH) {
        newList[index].title.titleTH = value;
      } else {
        newList[index].title.titleEN = value;
      }
      setItemList(newList);
    };
  };

  const onChangeDescription = (index, lang) => {
    return (value) => {
      const newList = [...itemList];
      if (lang === langTH) {
        newList[index].description.descriptionTH = value;
      } else {
        newList[index].description.descriptionEN = value;
      }
      setItemList(newList);
    };
  };
  /**template grid content end**/

  /**template people content start**/
  function getSaveBeanPeopleContent(values) {
    let mainTitle = { titleTH: mainTitleTH, titleEN: mainTitleEN };
    let newItemList = peopleList.map((item) => {
      return {
        ...item,
        keywordList: keywordList,
      };
    });

    if (!editData) {
      let bean = {
        templateType: templateType,
        mainTitle: mainTitle,
        content: newItemList,
        urlSuffix: values.urlSuffix,
      };
      return { bean: bean };
    } else {
      let bean = JSON.parse(JSON.stringify(editData));
      bean.templateType = templateType;
      bean.mainTitle.titleTH = mainTitleTH;
      bean.mainTitle.titleEN = mainTitleEN;
      bean.content = newItemList;
      bean.urlSuffix = values.urlSuffix;
      return { bean: bean };
    }
  }

  const onAddPeople = (e) => {
    e.preventDefault();
    const newList = [...peopleList];
    newList.push({
      attachImage: [],
      firstname: { firstnameTH: null, firstnameEN: null },
      lastname: { lastnameTH: null, lastnameEN: null },
      department: { departmentTH: null, departmentEN: null },
      position: { positionTH: null, positionEN: null },
      email: null,
      responsibilities: { responsibilitiesTH: [], responsibilitiesEN:[] },
    });
    setPeopleList(newList);
  };

  const onRemovePeople = (index) => {
    return () => {
      const newList = [...peopleList];
      newList.splice(index, 1);
      setPeopleList(newList);
    };
  };

  const onChangeFirstName = (index, lang) => {
    return (value) => {
      const newList = [...peopleList];
      if (lang === langTH) {
        newList[index].firstname.firstnameTH = value;
      } else {
        newList[index].firstname.firstnameEN = value;
      }
      setPeopleList(newList);
    };
  };

  const onChangeLastName = (index, lang) => {
    return (value) => {
      const newList = [...peopleList];
      if (lang === langTH) {
        newList[index].lastname.lastnameTH = value;
      } else {
        newList[index].lastname.lastnameEN = value;
      }
      setPeopleList(newList);
    };
  };

  const onChangeDepartment = (index, lang) => {
    return (value) => {
      const newList = [...peopleList];
      if (lang === langTH) {
        newList[index].department.departmentTH = value;
      } else {
        newList[index].department.departmentEN = value;
      }
      setPeopleList(newList);
    };
  };

  const onChangePosition = (index, lang) => {
    return (value) => {
      const newList = [...peopleList];
      if (lang === langTH) {
        newList[index].position.positionTH = value;
      } else {
        newList[index].position.positionEN = value;
      }
      setPeopleList(newList);
    };
  };

  const onChangeEmail = (index) => {
    return (value) => {
      const newList = [...peopleList];
      newList[index].email = value;
      setPeopleList(newList);
    };
  };

  const onChangeResponsibilities = (personIndex, lang, respIndex) => {
    return (value) => {
      const newList = [...peopleList];
      // Clone Object ด้านในเพื่อเปลี่ยน Reference ให้ React รู้ว่ามีการอัปเดต
      const currentResponsibilities = {
        ...newList[personIndex].responsibilities,
      };

      if (lang === langTH) {
        const updatedTH = [
          ...(currentResponsibilities?.responsibilitiesTH || []),
        ];
        updatedTH[respIndex] = value;
        currentResponsibilities.responsibilitiesTH = updatedTH;
      } else {
        const updatedEN = [
          ...(currentResponsibilities.responsibilitiesEN || []),
        ];
        updatedEN[respIndex] = value;
        currentResponsibilities.responsibilitiesEN = updatedEN;
      }

      newList[personIndex].responsibilities = currentResponsibilities;
      setPeopleList(newList);
    };
  };

  const onAddResponsibility = (personIndex, lang) => {
    return () => {
      const newList = [...peopleList];
      const currentResponsibilities = {
        ...newList[personIndex].responsibilities,
      };
      console.log("lang", lang);
      if (lang === langTH) {
        // นำ Array เดิมมากระจายออก และต่อด้วยค่าว่าง (สร้าง Array ใหม่แทนการ push)
        currentResponsibilities.responsibilitiesTH = [
          ...(currentResponsibilities?.responsibilitiesTH || []),
          "",
        ];
      } else {
        currentResponsibilities.responsibilitiesEN = [
          ...(currentResponsibilities?.responsibilitiesEN || []),
          "",
        ];
      }

      newList[personIndex].responsibilities = currentResponsibilities;
      setPeopleList(newList);
    };
  };

  const onRemoveResponsibility = (personIndex, lang, respIndex) => {
    return () => {
      const newList = [...peopleList];
      const currentResponsibilities = {
        ...newList[personIndex].responsibilities,
      };

      if (lang === langTH) {
        const updatedTH = [
          ...(currentResponsibilities.responsibilitiesTH || []),
        ];
        updatedTH.splice(respIndex, 1);
        currentResponsibilities.responsibilitiesTH = updatedTH;
      } else {
        const updatedEN = [
          ...(currentResponsibilities.responsibilitiesEN || []),
        ];
        updatedEN.splice(respIndex, 1);
        currentResponsibilities.responsibilitiesEN = updatedEN;
      }

      newList[personIndex].responsibilities = currentResponsibilities;
      setPeopleList(newList);
    };
  };

  const onChangeImagePeopleContent = (index) => {
    return ({ file }) => {
      if (file.status === "done") {
        const { bean } = file.response;
        const newList = [...peopleList];
        newList[index].attachImage = [bean];
        setPeopleList(newList);
      }
    };
  };

  const renderPeopleTemplateMain = () => {
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="ภาษาไทย" key={"People" + langTH}>
            {renderMainTitle(langTH)}
          </TabPane>
          <TabPane tab="English" key={"People" + langEN}>
            {renderMainTitle(langEN)}
          </TabPane>
        </Tabs>

        {peopleList.length > 0 && (
          <SortableList
            axis={"y"}
            useDragHandle
            items={peopleList}
            onSortEnd={({ oldIndex, newIndex }) => {
              setPeopleList(arrayMove(peopleList, oldIndex, newIndex));
            }}
            onChangeFirstName={onChangeFirstName}
            onChangeLastName={onChangeLastName}
            onChangeDepartment={onChangeDepartment}
            onChangePosition={onChangePosition}
            onChangeEmail={onChangeEmail}
            onChangeResponsibilities={onChangeResponsibilities}
            onAddResponsibility={onAddResponsibility}
            onRemoveResponsibility={onRemoveResponsibility}
            renderTabPeopleContent={renderTabPeopleContent}
            onChangeImagePeopleContent={onChangeImagePeopleContent}
            onRemovePeople={onRemovePeople}
            editData={editData}
          />
        )}

        <div className="text-right mt-3">
          <Button type="primary" className="me-2" onClick={onAddPeople}>
            <Icon.Plus className="me-1" size={18} />
          </Button>
        </div>
      </div>
    );
  };

  /*temlate people content end*/

  return (
    <div className="container h-100">
      <div className="title-page">
        <Modal
          title={editData ? "แก้ไขเนื้อหา" : "เพิ่มเนื้อหา"}
          bodyStyle={{ overflowY: "scroll" }}
          centered
          width={1000}
          visible={isShow}
          onCancel={onCancel}
          destroyOnClose
          maskClosable={false}
          footer={[
            <Button key="submit" type="primary" onClick={onSave}>
              <Icon.Save className="me-2" size={17} />
              บันทึก
            </Button>,
            <Button key="back" className="btn-gray" onClick={onCancel}>
              ยกเลิก
            </Button>,
            <Button className="mx-2 btn-line" onClick={() => onPreview()}>
              <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
            </Button>,
          ]}
        >
          {/* initialValues={{templateType: editData ? editData.templateType : 0}} */}
          <Form
            layout="vertical"
            name="add_edit_template_content"
            preserve={false}
            form={form}
            initialValues={{
              urlSuffix: editData?.urlSuffix,
              /*
                NMU-598: seeded here rather than in each layout's own
                setFieldsValue, because those only set the fields they list and
                this one is in the shared tail — so every layout gets it from
                one line. A page saved before the field existed has no value;
                PUBLIC is what it has always behaved as.
              */
              visibility: editData?.visibility || VISIBILITY_DEFAULT,
            }}
          >
            <Col xs={16}>
              <Form.Item
                label="รูปแบบ"
                name="templateType"
                initialValue=""
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  defaultValue="0"
                  onChange={onTemplateChange()}
                  value={templateType}
                >
                  <Option value="">โปรดระบุ</Option>
                  {renderTemplateList()}
                </Select>
              </Form.Item>
            </Col>
            {renderTemplate()}
            <div className="mt-3">
              <Form.Item label="คีย์เวิร์ด">
                <EditableTagGroup
                  onChange={setKeywordList}
                  tags={keywordList}
                />
              </Form.Item>
            </div>
            <div className="mt-3">
              <Form.Item
                label="URL Name"
                name="urlSuffix"
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Input />
              </Form.Item>
            </div>
            {/*
              NMU-598: the last field of the form, for every layout.

              It sits here rather than inside `renderTemplate()` because this
              tail is the part every template type shares — the ticket asks for
              it on Article, Grid Content, Organizational Structure, Programs,
              Multiple Tab "etc.", and adding it per layout would be six copies
              and a seventh forgotten the next time a layout is added.
            */}
            <div className="mt-3">
              <VisibilityFormItem />
            </div>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default AddEditTemplateContentDialog;
